// Kosinus-Ähnlichkeit zwischen zwei Vektoren (0-1, höher = ähnlicher)
export function cosineSimilarity(a: number[], b: number[]): number {
  if (a.length !== b.length) return 0;

  const dotProduct = a.reduce((sum, val, i) => sum + val * b[i], 0);
  const magnitudeA = Math.sqrt(a.reduce((sum, val) => sum + val * val, 0));
  const magnitudeB = Math.sqrt(b.reduce((sum, val) => sum + val * val, 0));

  if (magnitudeA === 0 || magnitudeB === 0) return 0;
  return dotProduct / (magnitudeA * magnitudeB);
}

// Kosinus-Distanz (0-1, niedriger = ähnlicher)
export function cosineDistance(a: number[], b: number[]): number {
  return 1 - cosineSimilarity(a, b);
}

// Euklidische Distanz
export function euclideanDistance(a: number[], b: number[]): number {
  if (a.length !== b.length) return 0;
  const sum = a.reduce((acc, val, i) => acc + Math.pow(val - b[i], 2), 0);
  return Math.sqrt(sum);
}

// Manhattan-Distanz
export function manhattanDistance(a: number[], b: number[]): number {
  if (a.length !== b.length) return 0;
  return a.reduce((sum, val, i) => sum + Math.abs(val - b[i]), 0);
}
